export var timeseriesOptions = function timeseriesOptions(theme) {
  return {
    credits: {
      enabled: false
    },
    accessibility: {
      enabled: false
    },
    chart: {
      backgroundColor: 'transparent'
    },
    yAxis: {
      opposite: false,
      showFirstLabel: false,
      lineColor: theme.colors.uiM,
      labels: {
        align: 'right',
        format: '{value:.0f}%'
      }
    },
    xAxis: {
      type: 'datetime',
      lineColor: theme.colors.ui,
      labels: {
        style: {
          fontSize: 11,
          color: theme.colors.uiD
        }
      },
      tickColor: theme.colors.ui,
      tickLength: 8
    },
    scrollbar: {
      enabled: false
    },
    navigator: {
      enabled: false
    },
    series: [],
    legend: {
      enabled: false
    },
    rangeSelector: {
      floating: false,
      buttonTheme: {
        fill: 'none',
        height: 20,
        width: 64,
        states: {
          hover: {
            fill: theme.colors.ui
          },
          select: {
            fill: theme.colors.uiM
          }
        },
        style: {
          fontSize: 14
        }
      },
      selected: 1,
      inputEnabled: true,
      inputDateFormat: '%b %e, %Y',
      inputStyle: {
        fontSize: 14,
        backgroundColor: 'white',
        color: theme.colors.primary,
        border: '1px solid silver',
        borderRadius: '5px',
        padding: '5px'
      },
      inputBoxHeight: 30,
      inputBoxWidth: 110,
      labelStyle: {
        fontSize: 18
      },
      buttons: [{
        type: 'ytd',
        count: 1,
        text: 'YTD'
      }, {
        type: 'year',
        count: 1,
        text: '1A'
      }, {
        type: 'year',
        count: 3,
        text: '3A'
      }, {
        type: 'year',
        count: 5,
        text: '5A'
      }, {
        type: 'year',
        count: 10,
        text: '10A'
      }, {
        type: 'all',
        text: 'Todo'
      }]
    },
    title: {
      text: ''
    },
    tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}€</b> ({point.change}%)<br/>',
      changeDecimals: 2,
      valueDecimals: 2
    },
    responsive: {
      rules: [{
        condition: {
          maxWidth: 500
        },
        chartOptions: {
          chart: {
            height: 320
          }
        }
      }]
    }
  };
};